import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import FormLabel from '@mui/material/FormLabel';
import { DEFAULT_PRIMARY_FONT_FAMILY } from 'theme/fontDefaults';

export const StFormLabel = styled(FormLabel)(({ theme }) => ({
  fontFamily: `${
    theme?.palette?.primaryFontFamilyType || DEFAULT_PRIMARY_FONT_FAMILY
  } Regular, sans-serif`,
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '14px',
  color: `${theme.palette.white.main}`,
  margin: 0,
  display: 'flex',
  alignItems: 'center',
  '&.Mui-focused': {
    color: `${theme.palette.white.main}`,
  },
}));

export const StInputBase = styled(InputBase, {
  shouldForwardProp: (prop) => prop !== 'errors',
})<any>(({ theme, errors }) => ({
  color: `${theme.palette.black.main} !important`,
  background: theme.palette.white.main,
  borderRadius: '4px',
  padding: errors ? '10px 8px' : '10px 15px',
  marginTop: '5px',
  fontFamily: `${theme?.palette?.primaryFontFamilyType || DEFAULT_PRIMARY_FONT_FAMILY}, sans-serif`,
  fontSize: '16px',
  lineHeight: '16px',
  fontWeight: 400,
  height: '40px',
  '.MuiInputBase-input': {
    padding: '4px 0',
  },
  '&:hover': {
    border: `1px solid ${theme.palette.neutral8.main}`,
  },
  '&.Mui-focused': {
    border: `1px solid ${theme.palette.white.main}`,
  },
  '& ::placeholder': {
    color: `${theme.palette.neutral6.main} !important`,
    fontFamily: `${
      theme?.palette?.primaryFontFamilyType || DEFAULT_PRIMARY_FONT_FAMILY
    }, sans-serif`,
    fontSize: '16px',
    lineHeight: '16px',
    opacity: 0.5,
  },
}));
